import { createSelector } from 'reselect';
import authCompany from 'store/selectors/authCompany';

export default createSelector(authCompany, company => company.divisions?.length > 0);
